import { isSeededMapEntryHref, resolveMapEntryHref } from '~/constants/maps';
import { isMigratedPathname } from '~/i18n/i18n-config';
import { getPathname } from '~/i18n/navigation';
import type { MenuItem } from '~/types/Menu.types';

// Raw <a> takes the href verbatim, so internal links are localised here. The map link counts as
// internal once resolved, although Dato flags it external. Non-migrated routes only exist
// unprefixed, so they're left as-is — the same rule as ~/components/Link.
export const toNavHref = (item: Pick<MenuItem, 'url' | 'isExternal'>, locale: string): string => {
  const href = resolveMapEntryHref(item.url, locale);
  const isExternal = !isSeededMapEntryHref(href) && item.isExternal;
  const isLocalisable = href.startsWith('/') && isMigratedPathname(href.split(/[?#]/)[0]);
  return !isExternal && isLocalisable ? getPathname({ href, locale }) : href;
};
